import React, { FC } from 'react'

import { Container, createStyles, makeStyles } from '@material-ui/core'

import Footer from './Footer'
import Header from './Header'

const useStyles = makeStyles(
  (theme) =>
    createStyles({
      page: {
        display: 'flex',
        flexDirection: 'column',
        height: '100%',
        minHeight: '100vh'
      },

      container: {
        flex: 1,
        minWidth: 0,
        marginTop: 74,
        padding: theme.spacing(5, 0)
      }
    }),
  { name: 'AppLayout' }
)

type LayoutProps = {}

const AppLayout: FC<LayoutProps> = ({ children }) => {
  const s = useStyles()

  return (
    <div className={s.page}>
      <Header />

      <main className={s.container}>
        <Container maxWidth="xl">{children}</Container>
      </main>

      <Footer />
    </div>
  )
}

export default AppLayout
